import React, { FC } from 'react'
import { HeroProps } from 'src/components/Hero/types'

import { MainLayoutProps } from '../../layouts'
import Breadcrumb, { BreadcrumbProps } from '../../components/Breadcrumb'

import * as SC from './styled'

export type PageTemplateProps = MainLayoutProps & {
  hero?: HeroProps
  children?: React.ReactNode
  breadcrumbProps?: BreadcrumbProps
}

const PageTemplate: FC<PageTemplateProps> = ({
  children,
  hero,
  breadcrumbProps,
  ...layoutProps
}) => {
  return (
    <SC.Layout {...layoutProps}>
      <SC.Top>
        {hero ? (
          hero.pictureProps ? (
            <SC.Hero {...hero} />
          ) : (
            <SC._HeroText {...hero} />
          )
        ) : (
          <></>
        )}
        <Breadcrumb {...breadcrumbProps} />
      </SC.Top>
      {children}
    </SC.Layout>
  )
}

export default PageTemplate
